/* eslint-disable react-hooks/exhaustive-deps */
import * as contentful from 'contentful';
import React, { createContext, useState, useEffect } from 'react';
import { useBrandDetails } from 'dw-au-react-components';

export const ContentfulContext = createContext();

export const ContentfulProvider = ({ children }) => {
	const brandData = useBrandDetails();
	const [loading, setLoading] = useState(true);
	const [blogLandingData, setBlogLandingData] = useState([]);
	const [blogConfigData, setBlogConfigData] = useState();
	const [topBlogPosts, setTopBlogPosts] = useState([]);
	const isPreview = new URL(window.location.href).searchParams.get('preview')
		? true
		: false;

	const client = contentful.createClient({
		space: '759ah7skns84',
		...(isPreview && { host: 'preview.contentful.com' }),
		accessToken: isPreview
			? 'lo_AIhv7unvx5CBSv8cMWMtugozF1y7_aL8S_M-9Aqw'
			: 'WRSJ8s9akgwwr-ejARj8VUrKv67gUu8NhjnhYZu35-0'
	});

	const params = {
		content_type: 'blog'
	};
	params['fields.brand[match]'] = brandData.tag;

	const fetchContentfulData = () => {
		setLoading(true);

		client
			.getEntries(params)
			.then((response) => {
				response.items.map((item) => {
					setBlogLandingData((prev) => [
						...prev,
						{ ...item.fields, sys: item.sys }
					]);
				});
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
			});
	};

	const fetchBlogConfig = () => {
		setLoading(true);

		client
			.getEntries({
				content_type: 'blogConfig',
				'fields.brand[match]': brandData.tag
			})
			.then((response) => {
				let item = response?.items[0]?.fields;
				if (item) {
					setBlogConfigData(item);

					let topPosts = [];
					if (item?.topPosts.length > 0) {
						item?.topPosts.map((blog, index) => {
							if (blog?.fields) {
								topPosts.push({
									...blog?.fields,
									sys: blog.sys,
									imageAlignment:
										index === 0
											? item?.topPost1ImageAlignment
											: index === 1
											? item?.topPost2ImageAlignement
											: item?.topPost3ImageAlignment
								});
							}
						});
						setTopBlogPosts(topPosts);
					}
				}
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
			});
	};

	useEffect(() => {
		fetchContentfulData();
		fetchBlogConfig();
	}, []);

	return (
		<ContentfulContext.Provider
			value={{
				blogLandingData,
				blogConfigData,
				topBlogPosts
			}}
		>
			{loading ? <div className='loading' /> : children}
		</ContentfulContext.Provider>
	);
};
